import { useFetcherData } from "v2/hooks/useFetcherData";

import { FetcherKeys } from "routes/dataroutes/Fetchers";

import { useSubscriptionSynchronizer } from "v2/hooks/billing/useSubscriptionSynchronizer";

import { ExtractFetcherDataType } from "routes/data-routes/types";
import {
  ActiveSubscriptionDataRoutePath,
  ActiveSubscriptionDataRouteType
} from "routes/data-routes/billing-data/active-subscription/route.meta";


type HookReturnType = ReturnType<NonNullable<ActiveSubscriptionDataRouteType["useActiveSubscription"]>>;
type FetcherDataType = ExtractFetcherDataType<HookReturnType>;

export function useActiveSubscription(): HookReturnType {
  const { value, error, fetcher, reload } = useFetcherData<FetcherDataType>({
    fetcherKey: FetcherKeys.ACTIVE_SUBSCRIPTION,
    fetcherHref: ActiveSubscriptionDataRoutePath,
    reloadOnFocus: true
  });

  // subscription synchronization part
  useSubscriptionSynchronizer({ subscription: value?.activeSubscription, reloadSubscription: reload });

  return {
    activeSubscription: value?.activeSubscription,
    activeSubscriptionError: error,
    activeSubscriptionFetcher: fetcher,
    reloadActiveSubscription: reload
  };
}
